angular.module('eStories.freeaudiobook', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.freeaudiobook', {
                url: 'freeaudiobook',
                views: {
                    'mainView@': {
                        templateUrl: 'home/freeaudiobook/freeaudiobook.tmpl.html',
                        controller: 'FreeaudiobookCtrl as freeaudiobookCtrl'
                    }
                }
            });
    }])

    .controller('FreeaudiobookCtrl', [
        'CatalogModel',
        'BillingModel',
        '$rootScope',
        '$state',
        'AccountModel',
        'SeoModel',
        'GA',
        '$location',
        function (CatalogModel, BillingModel, $rootScope, $state, AccountModel, SeoModel, GA, $location) {

            var freeaudiobookCtrl = this;

            GA.trackPageView($location.path());

            SeoModel.applyMetaTags($state.current.name);

            if (!AccountModel.isEligibleForTrial()) {
                $state.go('eStories.navbars.home');
            }

            freeaudiobookCtrl.goToHome = function () {
                $state.go('eStories.navbars.starttrial');
            };

        }]);
